exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".style1{font-size:20px;font-weight:600;line-height:80px}.style2,.style3{font-size:16px;line-height:30px}.style4{font-size:17px;line-height:28px;margin:20px 0}.style5{text-align:center;font-size:18px;font-weight:600;line-height:30px;margin:25px 0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-3daa37bb","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/msg1.vue
// module id = 222
// module chunks = 1